var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppAccessCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7273 2H4.81818C3.81818 2 3 2.81818 3 3.81818V16.5455H4.81818V3.81818H15.7273V2ZM18.4545 5.63636H8.45455C7.45455 5.63636 6.63636 6.45455 6.63636 7.45455V20.1818C6.63636 21.1818 7.45455 22 8.45455 22H18.4545C19.4545 22 20.2727 21.1818 20.2727 20.1818V7.45455C20.2727 6.45455 19.4545 5.63636 18.4545 5.63636ZM18.4545 20.1818H8.45455V7.45455H18.4545V20.1818Z",
    fill: "#6E758B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAccessCopy);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTUuNzI3MyAySDQuODE4MThDMy44MTgxOCAyIDMgMi44MTgxOCAzIDMuODE4MThWMTYuNTQ1NUg0LjgxODE4VjMuODE4MThIMTUuNzI3M1YyWk0xOC40NTQ1IDUuNjM2MzZIOC40NTQ1NUM3LjQ1NDU1IDUuNjM2MzYgNi42MzYzNiA2LjQ1NDU1IDYuNjM2MzYgNy40NTQ1NVYyMC4xODE4QzYuNjM2MzYgMjEuMTgxOCA3LjQ1NDU1IDIyIDguNDU0NTUgMjJIMTguNDU0NUMxOS40NTQ1IDIyIDIwLjI3MjcgMjEuMTgxOCAyMC4yNzI3IDIwLjE4MThWNy40NTQ1NUMyMC4yNzI3IDYuNDU0NTUgMTkuNDU0NSA1LjYzNjM2IDE4LjQ1NDUgNS42MzYzNlpNMTguNDU0NSAyMC4xODE4SDguNDU0NTVWNy40NTQ1NUgxOC40NTQ1VjIwLjE4MThaIiBmaWxsPSIjNkU3NThCIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };